namespace InvData {
  export class Manager {
    public id: number;
    public resourceId: number;
    public name: string;
    public code: string;
    public managerTypeId: number;
    public iardCrdNumber?: number;
  }
}